import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { services } from '../mockData';
import { ArrowRight, Check } from 'lucide-react';

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const service = services.find(s => s.id === serviceId);

  if (!service) {
    return (
      <div className="page-container">
        <div className="error-container">
          <h1>Service Not Found</h1>
          <Link to="/" className="btn-primary">Return Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      {/* Service Hero */}
      <section className="service-hero">
        <div className="service-hero-content">
          <div className="service-hero-text">
            <h1 className="page-title">{service.title}</h1>
            <p className="service-hero-desc">{service.fullDesc}</p>
            <Link to="/contact" className="btn-primary">
              Get a Quote
              <ArrowRight size={20} />
            </Link>
          </div>
          <div className="service-hero-image">
            <img src={service.image} alt={service.title} className="service-img" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features-section">
        <div className="service-features-content">
          <h2 className="section-title">Key Features</h2>
          <div className="features-grid">
            {service.features.map((feature, index) => (
              <div key={index} className="feature-item">
                <Check className="feature-icon" size={20} />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="technologies-section">
        <h2 className="section-title">Technologies We Use</h2>
        <div className="technologies-grid">
          {service.technologies.map((tech, index) => (
            <div key={index} className="technology-badge">
              {tech}
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <h2 className="service-cta-title">Ready to Get Started?</h2>
        <p className="service-cta-desc">
          Let's discuss how our {service.title.toLowerCase()} services can benefit your business.
        </p>
        <Link to="/contact" className="btn-cta">
          Contact Our Team
          <ArrowRight size={20} />
        </Link>
      </section>
    </div>
  );
};

export default ServiceDetail;
